import { useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";
import type { AppointmentBookingPage } from "@tellescope/types-models";

export interface UseAppointmentBookingPagesOptions {
  limit?: number;
  /** Whether to enable the query (defaults to true) */
  enabled?: boolean;
}

/**
 * Hook for fetching appointment booking pages available to the enduser.
 *
 * Returns all appointment booking pages sorted by title.
 */
export function useAppointmentBookingPages(options: UseAppointmentBookingPagesOptions = {}) {
  const { limit = 50, enabled = true } = options;

  const query = useTellescopeInfiniteQuery({
    model: "appointment_booking_pages",
    method: "getSome",
    request: {
      filter: {},
      limit,
    },
    select: (data) => data.pages.flat(),
    enabled,
  });

  const allBookingPages = (query.data ?? []) as AppointmentBookingPage[];

  // Sort by title (A-Z)
  const sortedBookingPages = [...allBookingPages].sort((a, b) => {
    const titleA = a.title || "";
    const titleB = b.title || "";
    return titleA.localeCompare(titleB);
  });

  return {
    ...query,
    bookingPages: sortedBookingPages,
  };
}
